'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _PropertyDetails = require('./../PropertyDetails/PropertyDetails.scss');var styles = _interopRequireWildcard(_PropertyDetails);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var PropertyPaymentsBlock = function PropertyPaymentsBlock(properties) {var
  payments = properties.payments,isCottageForSale = properties.isCottageForSale,translate = properties.translate,isRtl = properties.isRtl;var
  maintenance = payments.maintenance,tax = payments.tax,rental = payments.rental;
  var title = isCottageForSale ? 'payments' : 'paymentsAndConditions';

  var renderPrice = function renderPrice(type) {return (
      _react2.default.createElement('span', null,
        type !== 'rental' && !isRtl && _react2.default.createElement('span', null, ' \u20AA '),
        properties.payments[type],
        type !== 'rental' && isRtl && _react2.default.createElement('span', null, ' \u20AA ')));};



  var renderPayment = function renderPayment(type) {return (
      _react2.default.createElement('div', null,
        _react2.default.createElement('p', { className: styles.titleType }, '' + (
          type === 'tax' ? translate('tax_for_two_months') : translate(type)), ':'), '\xA0',


        renderPrice(type)));};



  return (
    _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.row, properties.className) },
      _react2.default.createElement('span', { className: (0, _classnames2.default)(styles.title, 'payments-title') }, translate(title)),
      _react2.default.createElement('div', { className: (0, _classnames2.default)('payments-content') },
        maintenance !== 0 && maintenance && renderPayment('maintenance'),
        tax !== 0 && tax && renderPayment('tax'),
        rental && renderPayment('rental'))));



};exports.default =

PropertyPaymentsBlock;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PropertyDetailedInfo/PropertyPaymentsBlock/PropertyPaymentsBlock.js
// module id = 2831
// module chunks = 0